import "moment/locale/id";
import {
  CountDown,
  formatDate,
  formatDate2,
  formatTime,
} from "../../../components/helpers";
import moment from "moment";
import IsEmpty from "../../../components/helpers/IsEmpty";

export const convertHistoryPengembalian = (data) => {
  let converted = [];
  if (!data) return [];

  data.forEach((item, index) => {
    converted.push({
      key: index + 1,
      id: item?.id,
      tanggal_kirim_proses: moment(item?.delivery_date).toString(),
      tanggal_kirim: formatDate(item?.delivery_date),
      tanggal_kirim_detail: formatDate2(item?.delivery_date),
      waktu_kirim: formatTime(item?.delivery_date),
      no_sbg: item?.gadai.sbg_code,
      nama_nasabah: item?.gadai.customer.ktp_name,
      no_telp_nasabah: item?.gadai.customer.phone_1,
      barang_jaminan: item?.gadai.product_details,
      lokasi: !item?.gadai.outlet?.name ? "-" : item?.gadai.outlet.name,
      alamat: `${item?.address}`,
      lokasi_kirim: `${item?.address} ${item?.subdistrict} ${item?.city} ${item?.province}`,
      konfirmasi: CountDown(item?.gadai.due_date),
      kode_gadai: item?.gadai_id,
      kode_kurir: item?.employee_id,
      nama_kurir: `${item?.employee?.first_name} ${item?.employee?.last_name}`,
      gadai_picture: item?.gadai?.gadai_product_pictures[0]?.picture,
      no_telp_kurir: item?.employee?.phone,
      kondisi: item?.status,
      status:
        item?.status == "waiting-delivery" ? (
          "Menunggu Pengantaran"
        ) : item?.status == "done" || item?.status == "delivered" ? (
          <div className="text-success">Selesai</div>
        ) : item?.status == "draft" ? (
          "Draft"
        ) : (
          "res"
        ),
      ktp_nasabah: item?.gadai?.gadai_delivery_picture?.customer_ktp,
      ktp_penerima: item?.gadai?.gadai_delivery_picture?.receiver_ktp,
      sbg: item?.gadai?.gadai_delivery_picture?.sbg,
      sbg2: IsEmpty(item?.gadai?.gadai_delivery_picture?.sbg_2) ? '-' : 'Lihat File',
      image: item?.gadai?.gadai_product_pictures,
      imei: item?.gadai?.gadai_smartphone?.imei_number,
      gadai_delivery_picture_id: item?.gadai?.gadai_delivery_picture?.id,
    });
  });
  return converted;
};
